
import { Type, Mail, List, ToggleLeft, Calendar } from "lucide-react";
import { LucideIcon } from "lucide-react";
import type { ReactElement } from 'react';

export const fieldTypes = [
  { value: "text", label: "Szövegmező", description: "Egysoros szövegbevitel", icon: Type },
  { value: "email", label: "Email mező", description: "Email cím validációval", icon: Mail },
  { value: "choice", label: "Választómező", description: "Egy vagy több választási lehetőség", icon: List },
  { value: "switch", label: "Kapcsoló", description: "Be/ki kapcsoló", icon: ToggleLeft },
  { value: "date", label: "Dátumválasztó", description: "Dátum kiválasztása", icon: Calendar },
  { value: "textarea", label: "Szövegterület", description: "Többsoros szövegbevitel", icon: Type },
];

export const getFieldIcon = (type: string): ReactElement => {
  const fieldType = fieldTypes.find(t => t.value === type);
  const Icon: LucideIcon = fieldType?.icon || Type;
  return <Icon className="w-4 h-4" />;
};
